import * as moment from 'moment';
import 'moment-timezone';

export class Moment {

    public static GetTimeZone() {
        return moment.tz.guess();
    }

    public static SetFormat(date, format = 'DD/MM/YYYY hh:mm:ss a') {
        const momentDate = moment(date);
        return momentDate.tz(Moment.GetTimeZone()).format(format);
    }

    public static CurrentDateWithStartOfDay(format = 'DD/MM/YYYY hh:mm:ss a') {
        return moment().startOf('day').format(format);
    }

    public static CurrentTime(format = 'YYYY-MM-DD H:mm:ss') {
        return moment().format(format);
    }

    public static getYesterdayDateTime(format = 'DD/MM/YYYY hh:mm:ss a') {
        const yesterday = moment().subtract(1, 'days');
        return yesterday.tz(Moment.GetTimeZone()).format(format);
    }

    public static dateFormat(date, format = 'YYYY-MM-DD H:mm:ss') {
        return moment(date).format(format);
    }

    public static dateObject(date) {
        return new Date(date);
    }

    public static unixDate(date, format = 'DD/MM/YYYY hh:mm:ss a') {
        return moment.unix(date).format(format);
    }

    public static timeFormat(value, format = 'hh:mm A') {
        return moment(String(value), 'HH:mm:ss').format(format ? format : 'hh:mm A');
    }
}
